export default __webpack_public_path__ + "static/media/photo--lg--huda-5.6ee3e24f.jpg";